export enum DocumentStatus {
  PENDING = 'Pending',
  SIGNED = 'Signed',
  CANCELED = 'Canceled',
}
